module.exports = __webpack_public_path__ + "img/1508476192.483b39f9.jpg";